import img1 from "../../../../assets/images/examples/mediatheque/big.png";
import img2 from "../../../../assets/images/univs/archi_inter.jpg";
import img3 from "../../../../assets/images/univs/archi_outer.webp";
import img4 from "../../../../assets/images/univs/buiss_inter.jpg";
import img5 from "../../../../assets/images/univs/buiss_outer.webp";
import img6 from "../../../../assets/images/univs/design_inter.jpg";
import img7 from "../../../../assets/images/univs/design_outer.webp";
import img8 from "../../../../assets/images/univs/infou_inter.jpg";
import img9 from "../../../../assets/images/univs/infou_outer.jpg";

export const data = [
  {
    img: img1,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img2,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img3,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img4,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img5,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img6,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img7,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img8,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
  {
    img: img9,
    text: "- Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec tellus nulla -",
  },
];
